import React from 'react';
import ReactDOM from 'react-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';

const Preloader = ({ classes, usePortal }) => {
  const renderContent = () => (
    <div data-testid="preloader" className={classes.wrapper}>
      <CircularProgress className={classes.loader} />
      Loading ...
    </div>
  );

  if (usePortal) {
    return ReactDOM.createPortal(renderContent(), document.body);
  }

  return renderContent();
};

Preloader.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  usePortal: PropTypes.bool,
};

Preloader.defaultProps = {
  classes: {},
  usePortal: false,
};

export default Preloader;
